module.exports = __webpack_public_path__ + "assets/img/fresh.0d8ffb80.svg";